<app-modal [dismissible]="dismissible"
           [isLoading]="isLoading"
           class="popup-info">
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title"> {{ 'admin.lifts.trayModal.titleEdit'| translate }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <app-input-switch class="add-input-service"
                          onLabel="{{'generic.yes' | translate}}"
                          offLabel="{{'generic.no' | translate}}"
                          [formControl]="trayForm.get('forService')"
                          topLabel="{{'admin.lifts.trayModal.forService' | translate}}">
        </app-input-switch>
        <app-input
            type="number"
            [thousandSeparator]="''"
            [formControl]="trayForm.get('name')"
            [showErrors]="showValidations"
            [placeholder]="'admin.lifts.trayModal.name' | translate"
            label="{{ 'admin.lifts.slotModal.name' | translate }}">
        </app-input>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="primary"
                    class="create"
                    [disabled]="isLoading"
                    (click)="onSaveSlot()">
            {{ 'admin.lifts.trayModal.button' | translate }}
        </app-button>
    </div>
</app-modal>
